var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"followButton"},[_c('single-button',{staticClass:"btn",attrs:{"text":_vm.button.text,"color":_vm.button.color,"width":"3rem","height":"1.5rem","fontSize":"0.7rem","radius":"1rem","border":_vm.button.border,"background":_vm.button.background},on:{"know":_vm.toLike}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }